module.exports = __webpack_public_path__ + "static/img/assetLogin.0f6e2ffc.svg";